<template>
  <div id="course-list">
    <div class="cate-nav flex flex-wrap my-4">
      <span class="py-2">学科分类：</span>
      <span class="cate-item mr-4 mb-2 cursor-pointer"
        :class="subject.active ? 'active':''"
        v-for="subject in subjectList" 
        :key="subject.id"
        @click="getCourseList(subject.id, 1)"
      >
        {{ subject.name }}
      </span>
    </div>
    <div class="cate-nav flex flex-wrap my-4">
      <span class="py-2">课程分类：</span>
      <span class="cate-item mr-4 mb-2 cursor-pointer"
        :class="cate.active ? 'active':''"
        v-for="cate in cateList" 
        :key="cate.id"
        @click="getCourseList(cate.id, 2)"
      >
        {{ cate.name }}
      </span>
    </div>
    <div class="items-grid-view vx-row mt-4" v-if="courseList.length" appear>
      <div class="vx-col xxxl:w-1/6 xxl:w-1/5 lg:w-1/4 md:w-1/3 sm:w-1/2 w-full cursor-pointer"
        v-for="course in courseList" 
        :key="course.objectID" 
        :title="course.title"
        @click="goCourseChapter(course.id)"
      >
        <item-grid-view :item="course"></item-grid-view>
      </div>
    </div>
  </div>
</template>

<script>

import { courseList } from '@/api/course'

const ItemGridView = () => import('./components/ItemGridView');
export default {
  components: {
    ItemGridView
  },
  data() {
    return {
      tabs: [],
      courseList: [],
      cateList: [],
      subjectList: [],
      subjectId: 0,
      cateId: 0,
    }
  },
  created() {
    
  },
  mounted() {
    this.getCourseList()
  },
  computed: {
    
  },
  methods: {
    getCourseList(id = 0, mode = 1) {
      if (mode == 1) {
        this.subjectId = id
      } else if (mode == 2) {
        this.cateId = id
      }
      courseList({cate_id: this.cateId, subject_id: this.subjectId}).then(res => {
        if (res.code == 1) {
          this.courseList = res.data.list
          this.cateList = res.data.cate
          this.subjectList = res.data.subject
        }
      })
    },
    goCourseChapter(id) {
      this.$router.push({path: '/courseCenter/contents', query: {id: id}})
    }
  },
}
</script>

<style lang="scss" scoped>
  .cate-nav {
    .cate-item {
      display: inline-block;
      padding: 0.5rem 1.5rem;
      font-size: 12px;
      color: #5c5c5c;
      border: 1px solid #ccc;
      border-radius: 6px;
      transition: .5s;
    }
    .cate-item.active {
      color: #fff;
      background: rgba(var(--vs-primary),1)!important;
      border: 1px solid rgba(var(--vs-primary),1)!important;
    }
    .cate-item:hover {
      color: #fff;
      background: rgba(var(--vs-primary),1)!important;
      border: 1px solid rgba(var(--vs-primary),1)!important;
    }
  }
  @media (min-width: 1400px) {
    .xxl\:w-1\/5 {
      width: 20% !important;
    }
    
  }
  @media (min-width: 1980px) {
    .xxxl\:w-1\/6 {
      width: 16.6% !important;
    }
  }
</style>
